import { BestellingDto } from 'src/app/shared/api-models/models';
import {BestellingDorpelDto, BestellingNeutDto, BestellingSluitpotDto} from '../api-models/models';
import {Guid} from 'guid-typescript';

export class ModelFactory {

  public static createBestelling(): BestellingDto {
    const model = <BestellingDto> {};
    model.id = Guid.create().toString();
    model.afleverdatum = new Date();
    return model;
  }

  public static createBestellingDorpel(productType: string): BestellingDorpelDto {
    const model = <BestellingDorpelDto> {
      productType: productType,
      aantal: 1,
      aantalNeuten: 2,
      aantalSluitpotten: 0,
      guid: Guid.create().toString(),
      maatA: 0,
      maatZ: 0,
      bewerkingen: [],
      neuten: [
        this.createNeut(),
        this.createNeut()
      ],
      zaagmaat: 0,
      sluitpotten: []
    };
    
    return model;
  }

  public static createNeut(): BestellingNeutDto {
    const model = <BestellingNeutDto> {
      //daagmaat: 0
    };
    return model;
  }

  public static createSluitpot(): BestellingSluitpotDto {
    const model = <BestellingSluitpotDto> {
      //maat: 0
    };
    return model;
  }
}
